class UIWatcher {
  constructor(update) {
    this.debounce = this.debounce.bind(this);
    this.tick = this.tick.bind(this);

    this.raf = undefined;
    this.state = {
      scrollTop: 0,
    };

    this.update = update;

    this.watching = {
      scroll: false,
      resize: false,
    };
  }

  debounce({ type }) {
    const stopTimeout = `${type}Timeout`;

    window.clearTimeout(this[stopTimeout]);

    this.watching[type] = true;

    if (!this.raf) {
      this.tick();
    }

    this[stopTimeout] = window.setTimeout(() => {
      this.watching[type] = false;

      if (type === 'scroll' && this.state.scrollDirection !== 0) {
        this.trigger(type, 'scrollDirection', 0);
      }
    }, 100);
  }

  onResize() {
    const height = window.innerHeight;
    const width = window.innerWidth;

    if (this.state.height !== height) {
      this.trigger('resize', 'height', height);
    }

    if (this.state.width !== width) {
      this.trigger('resize', 'width', width);
    }
  }

  onScroll() {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const scrollDirection = scrollTop > this.state.scrollTop ? 1 : -1;

    if (this.state.scrollTop !== scrollTop) {
      this.trigger('scroll', 'scrollTop', scrollTop);

      if (this.state.scrollDirection !== scrollDirection) {
        this.trigger('scroll', 'scrollDirection', scrollDirection);
      }
    }
  }

  start() {
    document.addEventListener('scroll', this.debounce);
    window.addEventListener('resize', this.debounce);

    // setup the state
    this.onResize();
    this.onScroll();
  }

  stop() {
    document.removeEventListener('scroll', this.debounce);
    window.removeEventListener('resize', this.debounce);
  }

  tick() {
    if (this.watching.resize) {
      this.onResize();
    }

    if (this.watching.scroll) {
      this.onScroll();
    }

    if (this.watching.resize || this.watching.scroll) {
      this.raf = window.requestAnimationFrame(this.tick);
    } else {
      this.raf = undefined;
    }
  }

  trigger(type, key, data) {
    this.state[key] = data;
    this.update(type, key, data);
  }
}

export default (callback) => new UIWatcher(callback);
